import React, { useState } from 'react';
import { v4 as uuidv4 } from 'uuid'; 
import './ExpertForm.css';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

function AddExpertForm({ onSubmit, onClose }) {
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    meetingCharge: '',
    phone: '',
    address: '',
    profession: '',
    category: '',
    experience: '',
    qualifications: '',
    resumeDoc: null,
    proofDoc: null,
    profileImage: null,
    resumeDocName: null,
    proofDocName: null,
    profileImageName: null,
    isApproved: false,
  });

  const [error, setError] = useState('');

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleResumeFileChange = (e) => {
    const { files } = e.target;
  
    // Generate a smaller UUID
    const smallUUID = uuidv4().slice(0, 8); // Adjust length as needed
  
    setFormData((prev) => ({
      ...prev,
      ['resumeDoc']: files[0],
      [`resumeDocName`]: `${smallUUID}_${files[0].name}`, // Dynamically set doc name based on input name
    }));
  };
  const handleProofFileChange = (e) => {
    const { files } = e.target;
  
    // Generate a smaller UUID
    const smallUUID = uuidv4().slice(0, 8); // Adjust length as needed
  
    setFormData((prev) => ({
      ...prev,
      ['proofDoc']: files[0],
      [`proofDocName`]: `${smallUUID}_${files[0].name}`, // Dynamically set doc name based on input name
    }));
  };

  const handleProfileFileChange = (e) => {
    const { files } = e.target;
  
    // Generate a smaller UUID
    const smallUUID = uuidv4().slice(0, 8); // Adjust length as needed
  
    setFormData((prev) => ({
      ...prev,
      ['profileImage']: files[0],
      [`profileImageName`]: `${smallUUID}_${files[0].name}`, // Dynamically set doc name based on input name
    }));
  };

  const handleApprovedToggle = () => {
    setFormData((prev) => ({
      ...prev,
      isApproved: !prev.isApproved,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Validate file uploads
    if (!formData.profileImage || !formData.resumeDoc || !formData.proofDoc) {
      setError('All three files are required.');
      return;
    }

    const submissionData = new FormData();
    Object.keys(formData).forEach((key) => {
      submissionData.append(key, formData[key]);
    });

    onSubmit(submissionData);
  };

  return (
    <div className="expert-form-overlay">
      <div className="expert-form">
        <span className="close" onClick={onClose}>&times;</span>
        <h2>Add New Expert</h2>
        {error && <div className="error-message">{error}</div>}
        <form onSubmit={handleSubmit}>
          {/* Input Fields */}
          <div className="form-group">
            <label>Name:</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              required
            />
          </div>
          <div className="form-group">
            <label>Email:</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              required
            />
          </div>
          <div className="form-group">
            <label>Phone:</label>
            <input
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleInputChange}
              required
            />
          </div>
          <div className="form-group">
            <label>Password</label>
            <div className="email-verify">
              <input
                type={showPassword ? "text" : "password"}
                id="password"
                name="password"
                value={formData.password}
                onChange={handleInputChange}
                placeholder="Enter your password"
                required
              />
              <button
                type="button"
                className="show-password-btn"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </button>
            </div>
          </div>
          <div className="form-group">
            <label>Address:</label>
            <textarea
              name="address"
              value={formData.address}
              onChange={handleInputChange}
            />
          </div>
          <div className="form-group">
            <label>Meeting Charge:</label>
            <input
              type="number"
              name="meetingCharge"
              value={formData.meetingCharge}
              onChange={handleInputChange}
              required
            />
          </div>
          <div className="form-group">
            <label>Profession:</label>
            <input
              type="text"
              name="profession"
              value={formData.profession}
              onChange={handleInputChange}
            />
          </div>
          <div className="form-group">
            <label>Category:</label>
            <input
              type="text"
              name="category"
              value={formData.category}
              onChange={handleInputChange}
            />
          </div>
          <div className="form-group">
            <label>Experience:</label>
            <input
              type="text"
              name="experience"
              value={formData.experience}
              onChange={handleInputChange}
            />
          </div>
          <div className="form-group">
            <label>Qualifications:</label>
            <input
              type="text"
              name="qualifications"
              value={formData.qualifications}
              onChange={handleInputChange}
            />
          </div>
          {/* File Uploads */}
          <div className="form-group">
            <label>Resume Document (Required):</label>
            <input
              type="file"
              name="resumeDoc"
              onChange={handleResumeFileChange}
              required
            />
          </div>
          <div className="form-group">
            <label>Proof Document (Required):</label>
            <input
              type="file"
              name="proofDoc"
              onChange={handleProofFileChange}
              required
            />
          </div>
          <div className="form-group">
            <label>Profile Image (Required):</label>
            <input
              type="file"
              name="profileImage"
              onChange={handleProfileFileChange}
              required
            />
          </div>
          <button type="submit">Add Expert</button>
        </form>
      </div>
    </div>
  );
}

export default AddExpertForm;
